// Public contact-form submission client. Posts to the Phase 2 intake Lambda.
// The default base points at the public API Gateway; override via the
// element's `api` attribute if the route is wired elsewhere.
export const DEFAULT_API_BASE =
  'https://mzcd0ywjhc.execute-api.eu-north-1.amazonaws.com/attraxion-API';

export async function postContact({ apiBase = DEFAULT_API_BASE, slug, payload }) {
  try {
    const res = await fetch(`${apiBase}/public/connect/${encodeURIComponent(slug)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(payload),
    });
    let data = null;
    try { data = await res.json(); } catch { data = null; }
    return { ok: res.ok, status: res.status, data };
  } catch {
    return { ok: false, status: 0, data: null };
  }
}
